module.exports = ":host /deep/ input, textarea {\n    border-radius: 4px !important;\n}\n\n:host /deep/ textarea {\n    border-radius: 4px !important;\n}\n\n.margin-left-16 {\n    margin-left: 16px;\n}\n\n.code ul>li {\n    font-size: 12px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/product-data/catalogs/edit/catalog-edit.component.css
// module id = ./src/app/agora/components/product-data/catalogs/edit/catalog-edit.component.css
// module chunks = main